<template>
  <el-dialog
    top="10vh"
    class="menu-manage-dialog"
    :title="$t('Common.setLang')"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="dialogVisible"
    append-to-body
  >
    <div>
      <div class="tableDiv">
        <el-table :data="nameContent" class="speTab">
          <el-table-column :label="$t('Common.lang')" width="220">
            <template slot-scope="scope">
              <el-select v-model="scope.row.language" size="small" class="speInput" clearable>
                <el-option
                  v-for="item in languageList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="nameContent.some((name) => name.language === item.value)"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Product.productFuncName')" prop="name">
            <template slot-scope="scope">
              <el-input v-model="scope.row.name" size="small" class="speInput"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="date" :label="$t('Common.operation')" width="100" fixed="right">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('Common.delete')"
                placement="top-start"
              >
                <!--                v-if="nameContent && nameContent.length !== 1"-->
                <el-button type="text" size="mini" @click="deleteLang(scope.$index)">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-del_16"></use></svg
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="add-bt" @click="addLang">
          <span>{{ $t('Common.create') }}</span>
        </div>
      </div>
    </div>
    <div slot="footer">
      <hl-button type="border" @click="close">{{ $t('Common.cancel') }}</hl-button>
      <hl-button @click="save" :loading="loading">{{ $t('Common.save') }}</hl-button>
    </div>
  </el-dialog>
</template>

<script>
// import Descriptions from '@/components/Descriptions'
// import DescriptionsItem from '@/components/Descriptions/DescriptionsItem'
import { languageList } from '@/config/status.js'
export default {
  name: 'SetLang',
  components: {
    // Descriptions,
    // DescriptionsItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let validatename = (rule, value, callback) => {
      if (!this.form.name) {
        callback(new Error(`${this.$t('System.roleName')}`))
      } else {
        callback()
      }
    }
    return {
      languageList,
      nameContent: [{}],
      dialogVisible: this.visible,
      data: [],
      defalutKeys: [],
      loading: false,
      saveLoading: false,
      form: {
        id: '',
        name: '',
        state: 'enable',
        description: ''
      },
      rules: {
        name: [{ required: true, validator: validatename, trigger: 'blur' }]
      },
      isExpand: false,
      defaultExpandedKeys: []
    }
  },
  created() {
    if (this.row.length > 0) {
      console.log(this.row)
      this.nameContent = this.row
    }
  },
  methods: {
    // 添加语言
    addLang() {
      this.nameContent.push({})
    },
    // 删除语言
    deleteLang(index) {
      this.nameContent.splice(index, 1)
    },
    close() {
      this.$emit('update:visible', false)
    },
    checkForm() {
      let pass
      pass = this.nameContent.every((item) => {
        return item.language && item.name && item.language.length > 0 && item.name.length > 0
      })
      return pass
    },
    getMenuCascaderVal(val) {
      if (val) {
        this.ppid = val[val.length - 2]
      }
    },
    save() {
      if (!this.checkForm()) {
        this.$message.warning(`${this.$t('Product.setLangTips')}`)
        return
      }
      let nameContentObj = {}
      this.nameContent.forEach((item) => {
        nameContentObj[item.language] = item.name
      })
      console.log('nameContent', this.nameContent)
      console.log('nameContentObj', nameContentObj)
      this.close()
      this.$emit('saveLang', {
        nameContentObj: nameContentObj,
        nameContent: this.nameContent
      })

      //   if (!this.checkForm()) return
      //   this.loading = true
      //   let params = {
      //     ...this.form
      //   }
      //   let api = this.form.id ? this.$api.system.menu_update : this.$api.system.menu_add
      //   this.$ajax
      //     .post(api, params)
      //     .then(() => {
      //       this.$message.success(
      //         `${
      //           this.form.id
      //             ? `${this.$t('Common.editSuccess')}`
      //             : `${this.$t('Common.createSuccess')}`
      //         }`
      //       )
      //       this.close()
      //       this.$emit('refresh', {
      //         pid: this.form.pid,
      //         ppid: this.ppid
      //       })
      //     })
      //     .catch(() => {})
      //     .finally(() => {
      //       this.loading = false
      //     })
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .speInput {
  width: 200px !important;
  // height: 32px;
  .el-input.el-input--suffix {
    width: 180px !important;
    height: 32px !important;
  }
}
.tableDiv {
  background: #eff4fc;
  padding: 8px;
  border-radius: 8px;
}
/deep/ .speTab {
  tr {
    background: #eff4fc !important;
  }
}
.add-bt {
  margin-top: 8px;
  width: 100%;
  height: 32px;
  line-height: 32px;
  background: #ffffff;
  border: 2px dashed #dcdfe6;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  span {
    color: #2046c7;
  }
  &:hover {
    background: #eff4fc;
    border-radius: 4px;
    border: 2px dashed #dadfe6;
  }
  &:active {
    background: #e3e8f0;
    border-radius: 4px;
    border: 2px solid #dadfe6;
  }
}
</style>
